(function ($) {
    $.fn.isInViewport = function () {    
        let elementTop = $(this).offset().top;
        let elementBottom = elementTop + $(this).outerHeight();
    
        let viewportTop = $(window).scrollTop() + 80;
        let viewportBottom = viewportTop + 200;
    
        return elementBottom > viewportTop && elementTop < viewportBottom;
    };

    // Load here
    handleClickStickyMenu();
    handleScrollMissionBox();

    function handleClickStickyMenu() {
        let stickyMissisonLink = $('.sticky-mission-link');
        if(stickyMissisonLink.length) {
            stickyMissisonLink.on('click', function(event) {        
                // stickyMissisonLink.removeClass('active');
                let target = $(this.getAttribute('href'));    
                if (target.length) {
                    event.preventDefault();          
                    // $(this).addClass('active');
                    $('html, body').stop().animate({
                      scrollTop: target.offset().top - 100
                    }, 500);
                }
            });  
        }
    }

    function handleScrollMissionBox() {
        let missionBox = $('.mission-box');
        if(missionBox.length) {
            $(window).on('scroll', function() {
                missionBox.each(function(i,e) {    
                    if($(this).isInViewport()) {
                        $('.sticky-mission-link.active').removeClass('active');
                        $(`a[href="#${$(this).attr('id')}"]`).addClass('active');
                    }
                });
            }); 
        }
    }

})(jQuery);